export const iconFontAwesomePunctuationSymbolsHashtag = (
	<i className="fa-solid fa-hashtag"></i>
);
